<ng-container *transloco="let t">
  @if (product) {
    <app-product-json-ld [product]="product"></app-product-json-ld>
    <div
      class="phone-link"
      [class.mobile]="(biggerThan$ | async)?.xs"
      [class.widescreen]="(biggerThan$ | async)?.sm"
      [class.largecreen]="(biggerThan$ | async)?.md"
      [attr.aria-label]="
        product?.model || product?.title || t('title_activity_listing_settings')
      ">
      <section class="flex align-start justify-start full-width product-banner">
        <div class="picture-wrap">
          @if ((biggerThan$ | async)?.xs) {
            <span class="fixed-space-36" aria-hidden="true"></span>
          }
          <a
            class="phone-link"
            [routerLink]="urlFragment$ | async"
            [queryParams]="productParams$ | async"
            [class.mobile]="(biggerThan$ | async)?.xs"
            [class.widescreen]="(biggerThan$ | async)?.sm"
            [class.largecreen]="(biggerThan$ | async)?.md"
            [attr.aria-label]="
              product?.model || product?.title || t('title_activity_listing_settings')
            ">
            <app-picture
              class="picture"
              [class.wide-wrapper]="product?.category === 'LAPTOP'"
              [pictureUrl]="(product?.images || [])[0]"></app-picture>
          </a>
          @if (goodDeal) {
            <span class="deal-wrap">
              <popsy-icon-check-badge class="icon primary"></popsy-icon-check-badge>
              <span class="fixed-space-4" aria-hidden="true"></span>
              <h2 class="text-highlight badge-title">{{ t('label_staff_pick') }}</h2>
            </span>
          }
        </div>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <!-- GOOD DEAL -->
        @if (originalPrice) {
          <div
            class="flex flex-col align-start justify-center full-height full-width product-info"
            [class.good-deal]="goodDeal">
            <!-- eslint-enable -->
            @if (originalPrice && !goodDeal) {
              <div class="badges-wrap" [class.lower]="product.brand === 'AWEI'">
                <div
                  [class.rtl]="isRtl$ | async"
                  class="flex align-center justify-center badge">
                  {{ t('label_best_seller') }}
                </div>
                <span class="dynamic-space" aria-hidden="true"></span>
                @if (originalPrice) {
                  <app-featured-discount-badge
                    [price]="product?.price?.amount"
                    [originalPrice]="product?.originalPrice?.amount"
                    [flagMode]="true"></app-featured-discount-badge>
                }
              </div>
            }
            @if (originalPrice && goodDeal) {
              <div
                class="good-wrap"
                [class.rtl]="isRtl$ | async"
                [class.lower]="product.brand === 'AWEI'">
                @if (originalPrice) {
                  <app-featured-discount-badge
                    [price]="product?.price?.amount"
                    [originalPrice]="product?.originalPrice?.amount"
                    [goodDealMode]="true"></app-featured-discount-badge>
                }
              </div>
            }
            @if ((biggerThan$ | async)?.mobileL && goodDeal) {
              <span class="fixed-space-32" aria-hidden="true"></span>
            }
            @if (goodDeal) {
              <span class="fixed-space-32" aria-hidden="true"></span>
            }
            <!-- Title and Price -->
            <a
              class="header"
              [routerLink]="urlFragment$ | async"
              [queryParams]="productParams$ | async"
              [attr.aria-label]="
                product?.model || product?.title || t('title_activity_listing_settings')
              ">
              <span class="title-wrap" [class.flex]="goodDeal">
                <h3 class="text-gray-dark product-title">{{ product?.model || '' }}</h3>
              </span>
              <span class="price-wrap align-base">
                <h3 class="text-highlight bold">{{ product?.price | amount }}</h3>
              </span>
            </a>
            @if (product?.storage) {
              <div class="flex align-center justify-start metadata-info">
                <h3 class="full-width text-gray-dark name">
                  {{ (product?.storage || '') + 'GB' }}
                </h3>
                <span class="p-8">|</span>
                <h3 class="text-gray-dark">{{ product.color | translateColor }}</h3>
              </div>
            }
            <!-- GET ALL COLOR VARIANTS -->
            @if (product) {
              <app-product-color-variants
                [id]="product.id"
                [model]="product.model"
                [switchMode]="true"
                displayMode="small"
                (switchProductID)="
                  onSwitchProductID($event)
                "></app-product-color-variants>
            }
            <span class="fixed-space-32" aria-hidden="true"></span>
            <app-featured-buy-buttons
              class="full-width"
              [product]="product"></app-featured-buy-buttons>
          </div>
        }
      </section>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
  }

  @if (!product) {
    <section class="flex align-start justify-start full-width product-banner">
      <div class="flex flex-col align-center justify-start full-height">
        <popsy-skeleton class="picture skeleton" aria-hidden="true"></popsy-skeleton>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <div class="flex flex-col align-start justify-start full-height full-width">
        <span class="fixed-space-24" aria-hidden="true"></span>
        <div class="flex align-center justify-start full-width">
          <popsy-skeleton
            class="product-price skeleton"
            aria-hidden="true"></popsy-skeleton>
        </div>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <popsy-skeleton
          class="product-title skeleton"
          aria-hidden="true"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <span class="flex align-center icon-title">
          <span class="icon-wrap flex justify-start">
            <popsy-skeleton class="icon skeleton" aria-hidden="true"></popsy-skeleton>
            <span class="fixed-space-8" aria-hidden="true"></span>
            <popsy-skeleton
              class="verified-refurbished skeleton"
              aria-hidden="true"></popsy-skeleton>
          </span>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <!-- <span *ngIf="userReviews" class="icon-wrap flex justify-start">
          <popsy-icon-star-filled class="icon"></popsy-icon-star-filled>
        </span> -->
        </span>
        <span class="fixed-space-24" aria-hidden="true"></span>
        <div class="flex align-center justify-start full-width metadata-info">
          <popsy-skeleton
            class="color-circle skeleton"
            aria-hidden="true"></popsy-skeleton>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <popsy-skeleton
            class="full-width name skeleton"
            aria-hidden="true"></popsy-skeleton>
        </div>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex align-center justify-start full-width metadata-info">
          <popsy-skeleton class="icon skeleton" aria-hidden="true"></popsy-skeleton>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <popsy-skeleton
            class="full-width name skeleton"
            aria-hidden="true"></popsy-skeleton>
        </div>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex align-center justify-start full-width metadata-info">
          <popsy-skeleton class="icon skeleton" aria-hidden="true"></popsy-skeleton>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <popsy-skeleton
            class="full-width name skeleton"
            aria-hidden="true"></popsy-skeleton>
        </div>
        <span class="fixed-space-24" aria-hidden="true"></span>
        <popsy-skeleton
          class="button buy-button full-width skeleton"
          aria-hidden="true"></popsy-skeleton>
        <span class="fixed-space-16" aria-hidden="true"></span>
      </div>
    </section>
  }
</ng-container>
